/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Harden_Detail6Inputs */

const en_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording consent, cost caps, monitoring and fallback numbers.`)
};

const ar_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موافقة التسجيل وحدود التكلفة والمراقبة والأرقام الاحتياطية.`)
};

const bn_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেকর্ডিং সম্মতি, খরচের সীমা, মনিটরিং আর ব্যাকআপ নম্বর।`)
};

const de_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufzeichnungseinwilligung, Kostenlimits, Monitoring und Fallback-Nummern.`)
};

const es_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consentimiento de grabación, límites de coste, monitorización y números de respaldo.`)
};

const fr_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consentement d'enregistrement, plafonds de coût, supervision et numéros de secours.`)
};

const pt_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consentimento de gravação, limites de custo, monitorização e números de reserva.`)
};

const zh_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录音告知、成本上限、监控和备用号码。`)
};

const tr_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt onayı, maliyet tavanları, izleme ve yedek numaralar.`)
};

const ru_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласие на запись, лимиты затрат, мониторинг и резервные номера.`)
};

const pl_svc_ai_voice_agents_harden_detail6 = /** @type {(inputs: Svc_Ai_Voice_Agents_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgoda na nagrywanie, limity kosztów, monitoring i numery zapasowe.`)
};

/**
* | output |
* | --- |
* | "Recording consent, cost caps, monitoring and fallback numbers." |
*
* @param {Svc_Ai_Voice_Agents_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_harden_detail6 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_harden_detail6(inputs)
	return en_svc_ai_voice_agents_harden_detail6(inputs)
});
export { svc_ai_voice_agents_harden_detail6 as "svc_ai-voice-agents_HARDEN_detail" }